<template>
  <div>
    <d-table
      v-if="tableReady"
      :data_object="data_object"
      :getFreshData="true"
      :searchableColumns="searchableColumns"
      :linkClick="linkClick"
      :link="link"
      :itemsPerPage="15"
      :hasSearch="true"
      ref="dTable"
      :key="tableKey"
      :serverPagination="true"
      :showGroupBy="false"
      :sortBy="sortBy"
      :insertable="false"
      :editRow="true"
      :noCache="true"
      :addButtonCaption="addButtonCaption"
      :alwaysUpdate="true"
      :onDataReceived="onDataReceived"
      :editedItemTitle="editedItemTitle"
      tableName="employee"
      :columnTool="true"
      :defaultModel="defaultModel"
    />
  </div>
</template>

<script>
import * as fun from "../plugins/common";
export default {
  name: "Agents",
  components: {
    DTable: () => import("../components/Table.vue"),
  },
  props: {},
  data() {
    return {
      tableKey: 0,
      tableReady: false,
      getFreshData: true,
      type: "",
      data_object: {
        object_name: "v_employee",
        schema_name: "employee",
        object_name_to_update: "employee",
        delete_object_name: "employee",

        table_title: "Employee",
        all_records: true,
      },
      editedItemTitle: ["full_name"],
      searchableColumns: [],
      sortBy: "full_name",

      addButtonCaption: "Add Employee",
    };
  },
  mounted() {
    this.type = this.$router.currentRoute.params.type;
    var id = this.$router.currentRoute.params.id;
    if (this.type) {
      this.data_object.qry = { category: this.type + "_employee" };
      this.defaultModel = {
        category: this.type + "_employee",
        contact: {},
        address: {},
        availability: {},
        company: [],
        roles: [],
        color: "#" + fun.randomColor(),
        agent: {},
        crew: { crew: [], truck: [] },
        date_employed: fun.formatDate(new Date()),
      };
    } else {
      this.data_object.qry = { _id: id };
    }

    this.tableReady = true;
  },

  methods: {
    onDataReceived(d) {
      // d.schema.properties.category.default_value = this.type + "_employee";
      return d;
    },
  },
};
</script>

<style lang="css" scoped></style>
